import { useEffect } from "react";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { fetchActivityById } from "src/redux/slices/activities";
import { pick } from "src/utils/localize";
import { usePageMeta } from "src/utils/seo";

import Footer from "../../components/footer/footer";
import PageHero from "../../components/page-hero";
import ActivityInfo from "./activity-info";

const ActivityPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const { item: activity, status } = useSelector(
    (state) => state.activities.selectedActivity
  );

  useEffect(() => {
    dispatch(fetchActivityById(id));
  }, [id, dispatch]);

  usePageMeta({
    title: pick(activity?.name, i18n.language),
    description: pick(activity?.text, i18n.language),
  });

  // Раньше `if (!activity) return null` отдавал пустой белый экран без шапки
  // и футера, а ошибка была нелокализованной строкой "Error loading activity."
  return (
    <div className="bg-kj-dark text-kj-ink min-h-screen">
      <PageHero />
      <main
        aria-busy={status === "loading"}
        className="max-w-[1526px] w-full h-full mx-auto flex flex-col gap-y-10 px-4 mt-10 sm:mt-14 mb-12"
      >
        {status === "error" && (
          <p role="alert" className="text-kj-sub">
            {t("common.loadError")}
          </p>
        )}

        {status === "loading" && (
          <p role="status" className="text-kj-sub">
            {t("common.loading")}
          </p>
        )}

        {status !== "loading" && status !== "error" && activity && (
          <ActivityInfo activity={activity} />
        )}
      </main>
      {/* место под липкую полосу «Забронировать»: без него она перекрывает
          нижнюю часть футера на телефоне */}
      <div className="pb-[72px] lg:pb-0">
        <Footer />
      </div>
    </div>
  );
};

export default ActivityPage;
